import { isEssayChoiceGroup, resolveEssayPrompts } from './essayChoiceGroup';

export { isEssayChoiceGroup, resolveEssayPrompts };

/**
 * Strict TARA Writing "format G": exactly one essay_choice_group question with
 * exactly 3 essay_options and 3 resolved (non-instruction-blob) prompts.
 * Anything else fails closed to the cream essay flow.
 */
export function isTaraWritingFormatG(questions) {
  const raw = Array.isArray(questions) ? questions : [];
  if (raw.length !== 1) return false;
  const q = raw[0];
  if (!isEssayChoiceGroup(q)) return false;
  if (q.interaction_kind !== 'essay_choice_group') return false;
  if (!Array.isArray(q.essay_options) || q.essay_options.length !== 3) return false;
  const prompts = resolveEssayPrompts(q);
  if (prompts.length !== 3) return false;
  return true;
}
